import Vue from 'vue';
import DeleteRow from './DeleteRow';
import EditRow from './EditRow';
import CreateRow from './CreateRow';

Vue.component('m-table-btn-delete', DeleteRow);
Vue.component('m-table-btn-edit', EditRow);
Vue.component('m-table-btn-create', CreateRow);
